import React from "react";
import * as Icon from 'ubs-icons';
import {COLOR, POLICY_AUTOMATION, PROFILE_SECTION, REQUISITION_POLICY} from "ubs-framework/v2/common/constant";
import {getMobileOperatingSystem, isInApp} from "ubs-framework/v2/common/function";

export const APP = {
    COOKIE_DAYS: 90,
    DOMAIN: 'recruitqa1'
};

export const LIMIT = {
    SEARCH_CHARACTER: 2,
    TOAST_TIME_OUT: 5000,
    DE_BOUNCING_TIME_OUT: 500,
    DE_BOUNCING_TIME_OUT_TICKET: 1000,
};

// ATS team discriminator (team-level `type`) — a saved recruiter group belongs to exactly one
// feature so the two never share a list: 1 = Comparison saved preference, 2 = Team Summary team.
export const TEAM_TYPE = {
    COMPARISON: 1,
    TEAM_SUMMARY: 2,
};

export const IS_DEV = process.env.NODE_ENV === 'development'
export const FCM_CONFIG = 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window

export const CONSTANT = {
    PLATFORM: (isInApp() && ['Android', 'iOS'].includes(getMobileOperatingSystem())) ? getMobileOperatingSystem()?.toLowerCase() : 'web',
    STAGE_COLOR: [
        {label: '#007AFF', value: '#007AFF'},
        {label: '#9A5BFF', value: '#9A5BFF'},
        {label: '#FFA700', value: '#FFA700'},
        {label: '#005A8D', value: '#005A8D'},
        {label: '#FF449F', value: '#FF449F'},
        {label: '#60B158', value: '#60B158'},
        {label: '#FF6961', value: '#FF6961'},
        {label: '#72147E', value: '#72147E'},
        {label: '#4A503D', value: '#4A503D'},
        {label: '#1584D4', value: '#1584D4'},
    ],
    optionsList: [
        {
            label: 'Single line text',
            image: <Icon.Minus size={18} fill={COLOR.u_title}/>,
            value: 'singleline',
            question: ``,
            hint: ``,
            type: 1,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Multi line text',
            image: <Icon.Multiline size={18} fill={COLOR.u_title}/>,
            value: 'multiline',
            question: ``,
            hint: ``,
            type: 2,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Yes/No',
            image: <Icon.YesNo size={18} fill={COLOR.u_title}/>,
            value: 'yes/no',
            question: ``,
            hint: ``,
            type: 3,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Single choice',
            image: <Icon.CheckMark size={18} fill={COLOR.u_title}/>,
            value: 'singlechoice',
            question: ``,
            hint: ``,
            type: 4,
            required: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "",
                value: ""
            }, {
                label: "",
                value: ""
            }]
        },
        {
            label: 'Multiple choice',
            image: <Icon.DoubleTick size={18} fill={COLOR.u_title}/>,
            value: 'multiplechoise',
            question: ``,
            hint: ``,
            type: 5,
            required: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "",
                value: ""
            }, {
                label: "",
                value: ""
            }],
        },
        {
            label: 'Dropdown',
            image: <Icon.ListData size={18} fill={COLOR.u_title}/>,
            value: 'dropdown',
            question: ``,
            hint: ``,
            type: 6,
            required: false,
            isOtherOption: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "",
                value: ""
            }, {
                label: "",
                value: ""
            }]
        },
        {
            label: 'Address',
            image: <Icon.Location size={18} fill={COLOR.u_title}/>,
            value: 'address',
            question: ``,
            hint: ``,
            type: 7,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Gender',
            image: <Icon.Gender size={18} fill={COLOR.u_title}/>,
            value: 'gender',
            question: ``,
            hint: ``,
            type: 8,
            required: false,
            errorMessage: 'This question is mandatory',
            menuOptions: [{
                label: "Male",
                value: "Male"
            }, {
                label: "Female",
                value: "Female"
            }]
        },
        {
            label: 'Date of birth',
            image: <Icon.Calendar size={18} fill={COLOR.u_title}/>,
            value: 'date',
            question: ``,
            hint: ``,
            type: 9,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Nationality',
            image: <Icon.MileStones size={18} fill={COLOR.u_title}/>,
            value: 'nationality',
            question: ``,
            hint: ``,
            type: 10,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Language skill',
            image: <Icon.Language size={18} fill={COLOR.u_title}/>,
            value: 'language-skill',
            question: ``,
            hint: ``,
            type: 11,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Skill',
            image: <Icon.MultiSelect size={18} fill={COLOR.u_title}/>,
            value: 'skill',
            question: ``,
            hint: ``,
            type: 12,
            required: false,
            errorMessage: 'This question is mandatory'
        },
        {
            label: 'Scorecard',
            image: <Icon.NotSure size={18} fill={COLOR.u_title}/>,
            value: 'scorecard',
            question: ``,
            hint: ``,
            type: 18,
            required: false,
            errorMessage: 'This question is mandatory'
        },
    ],
    TIME_INTERVAL: [
        {value: 'TODAY', label: 'Today'},
        {value: 'YESTERDAY', label: 'Yesterday'},
        {value: 'LAST_WEEK', label: 'Last Week'},
    ],
    ACTIVITIES_TYPE_FILTERS: [
        {value: 'jobImported', label: 'Job Imported'},
        {value: 'hiringManagerUpdated', label: 'Hiring Manager Update'},
        {value: 'jobPostTypeUpdated', label: 'Job Post Type update'},
        {value: 'jobTitleUpdated', label: 'Job Title update'},
        {value: 'jobTypeUpdated', label: 'Job Type update'},
        {value: 'departmentUpdated', label: 'Department update'},
        {value: 'statusUpdated', label: 'Status update'},
        {value: 'priorityUpdated', label: 'Priority update'},
        {value: 'experienceUpdated', label: 'Experience update'},
        {value: 'salaryFromUpdated', label: 'Salary From update'},
        {value: 'salaryToUpdated', label: 'Salary To update'},
        {value: 'totalOpeningsUpdated', label: 'Total Opening update'},
        {value: 'openingDateUpdated', label: 'Opening date update'},
        {value: 'expireDateUpdated', label: 'Expire date update'},
        {value: 'locationUpdated', label: 'Location update'},
        {value: 'tagsUpdated', label: 'Tags update'},
        {value: 'hiringTeamUpdated', label: 'Hiring team update'},
        {value: 'jobDescriptionUpdated', label: 'Job description update'},
        {value: 'applicationFieldUpdated', label: 'Application field update'},
        {value: 'recruitmentStagesUpdated', label: 'Recruitment stages update'},
        {value: 'candidateAdded', label: 'Candidate update'},
        {value: 'candidateStageUpdated', label: 'Candidate Stage update'},
    ],
    REPORT_DATE: [
        {value: 'today', label: 'Today'},
        {value: 'yesterday', label: 'Yesterday'},
        {value: 'thisWeek', label: 'This week'},
        {value: 'lastWeek', label: 'Last Week'},
        {value: 'thisMonth', label: 'This Month'},
        {value: 'lastMonth', label: 'Last Month'},
        {value: 'last30', label: 'Last 30 Days'},
        {value: 'last60', label: 'Last 60 Days'},
        {value: 'customRange', label: 'Custom Range'},
    ],
    STAGE_TYPE_LIST: [
        {label: "Sourcing", value: 1},
        {label: "Applied", value: 2},
        {label: "In Review", value: 3},
        {label: "Interview", value: 4},
        {label: "On Hold", value: 5},
        {label: "Offered", value: 6},
        {label: "Hired", value: 7},
        {label: "Rejected", value: 8},
    ],
    CANDIDATE_VIEW: {
        LIST: 'list',
        KANBAN: 'kanban',
    },
    CANDIDATE_KANBAN_LIMIT: 10,
    STAGE_TYPE: {
        DEFAULT: 0,
        APPLIED: 1,
        IN_REVIEW: 2,
        INTERVIEW: 3,
        ON_HOLD: 4,
        OFFERED: 5,
        HIRED: 6,
        REJECTED: 7
    },
    BULK_ACTIONS_OPT: [
        {label: "Disqualified Candidate", value: 1},
        {label: "Mark as Active", value: 2},
        {label: "Mark as Inactive", value: 3},
        {label: "Mark as Archive", value: 4},
        {label: "Mark as UnArchive", value: 5},
        {label: "Add To Preboarding", value: 6},
        {label: "Delete Candidate", value: 7},
    ],
    BULK_ACTIONS: {
        DISQUALIFY_CANDIDATE: 1,
        MARK_AS_ACTIVE: 2,
        MARK_AS_INACTIVE: 3,
        MARK_AS_ARCHIVE: 4,
        MARK_AS_UNARCHIVE: 5,
        ADD_TO_PREBOARDING: 6,
        DELETE_CANDIDATE: 7
    },
    INTERVIEW_BULK_ACTIONS: {
        MARK_AS_COMPLETE: 1,
        INTERVIEW_DELETE: 2
    },
    BULK_ACTIONS_OPTIONS: [
        {label: "Mark as Complete", value: 1},
        {label: "Delete Interview", value: 2},
    ],
    MONTH_LIST: [
        {label: "January", value: 1, shortName: "Jan"},
        {label: "February", value: 2, shortName: "Feb"},
        {label: "March", value: 3, shortName: "Mar"},
        {label: "April", value: 4, shortName: "Apr"},
        {label: "May", value: 5, shortName: "May"},
        {label: "June", value: 6, shortName: "Jun"},
        {label: "July", value: 7, shortName: "Jul"},
        {label: "August", value: 8, shortName: "Aug"},
        {label: "September", value: 9, shortName: "Sep"},
        {label: "October", value: 10, shortName: "Oct"},
        {label: "November", value: 11, shortName: "Nov"},
        {label: "December", value: 12, shortName: "Dec"}
    ]
}

export const UAC_CONSTANT = {
    UAC: "ATS_UAC",
    HOLIDAY: "HOLIDAY",
    IPBLOCKING: "IPBLOCKING",
    OVERTIME: "OVERTIME",
    COMP_OFF: "COMPOFF",
    GEO: "GEO",
    PBD: "PBD",
    SHIFT: "SHIFT",
    WEEKEND: "WEEKEND",
    PAYROLL_SALARY_TEMPLATE: "PAYROLL_SALARY_TEMPLATE",
    WD: "WD",
    NWD: "NWD",
    LEAVE: "LEAVE",
    CLOCK_IN_SETTING: "CLOCK_IN_SETTING",
    POLICY_DOC: "POLICY_DOCUMENT",
    REFERRAL_POLICY: "REFERRAL_POLICY",
    SHIFT_SCHEDULER: "SHIFT_SCHEDULER",
    PRODUCT_ACCESS: "PRODUCT_ACCESS",
    REIMBURSEMENT: 'REIMBURSEMENT_TYPE',
    BIOMETRICS: "BIOMETRICS"
}
export const FILTERS_LIST = {
    search: "search",
    employeeType: "type",
    employee: "employee",
    company: "companyId",
    location: "location",
    subLocation: "subLocation",
    department: "department",
    subDepartment: "subDepartment",
    category: "category",
    jobTitle: "jobTitle",
    employeeStatus: "employeeStatus",
    businessUnit: "businessUnit",
    costCenter: "costCenter",
    grade: "grade",
    bands: "bands",
    segment: "segment",
    hub: "hub",
    territory: "territory",
    region: "region",
    workArea: "workArea",
}
export const DEFAULT_FILTERS = [
    {type: FILTERS_LIST?.company, isMultiple: true},
    {type: FILTERS_LIST?.location, isMultiple: true},
    {type: FILTERS_LIST?.subLocation},
    {type: FILTERS_LIST?.department, isMultiple: true},
    {type: FILTERS_LIST?.subDepartment, isMultiple: true},
    {type: FILTERS_LIST?.category, isMultiple: true},
    {type: FILTERS_LIST?.jobTitle, isMultiple: true},
    {type: FILTERS_LIST?.employeeStatus, isMultiple: true},
    {type: FILTERS_LIST?.businessUnit, isMultiple: true},
    {type: FILTERS_LIST?.costCenter, isMultiple: true},
    {type: FILTERS_LIST?.grade, isMultiple: true},
    {type: FILTERS_LIST?.bands, isMultiple: true},
    {type: FILTERS_LIST?.segment, isMultiple: true},
    {type: FILTERS_LIST?.hub, isMultiple: true},
    {type: FILTERS_LIST?.territory, isMultiple: true},
    {type: FILTERS_LIST?.region, isMultiple: true},
    {type: FILTERS_LIST?.workArea, isMultiple: true},
]
export const RESUME_SCORE_TYPE= [
    {label: 'High', value: 3},
    {label: 'Medium', value: 2},
    {label: 'Low', value: 1},
]
export const UAC_TYPE = {
    ADMIN: 1,
    RECRUITER: 2,
    INTERVIEWER: 3,
}

export const ACTIVITY_LOGS_TYPE = {
    CREATED: 1,
    MODIFIED: 2,
    REMOVED: 3
}

export const GLOBAL_COMMENT = {
    ATS_REQUISITION: 1051,
    ATS_CANDIDATE_CONVERSATION: 1016
}

{/** Backend Collection Name **/
}
export const COMMON_SETTING_LIST = {
    JOB_TYPE: 'ats_job_type',
    PRIORITY: 'ats_priority',
    STATUS: 'ats_status',
    TAG_AND_SOURCE: 'ats_tag_and_source',
    PIPELINE_STAGES_TEMPLATE: 'ats_pipeline_stages_template',
    DISQUALIFY_REASON: 'ats_disqualify_reason',
    EMAIL_TEMPLATE: 'ats_email_template',
}

export const DISQUALIFY_REASON_TYPE = {
    ADD_EMAIL: 1,
    ADD_NOTE: 2,
    ADD_TASK: 3,
    ADD_TAGS: 4
}

export const DOWNLOAD_REPORT_STATUS_OPTIONS = [
    {label: 'Pending', value: 1},
    {label: 'Failed', value: 2},
    {label: 'Success', value: 3}
];

export const MAIL_STATUS = [
    {label: 'Success', value: 1},
    {label: 'Failed', value: 2},
];

export const EMAIL_TEMPLATE = {
    PLACEHOLDER: [
        {title: "Candidate First Name", key: 'candidateFirstName'},
        {title: "Candidate Last Name", key: 'candidateLastName'},
        {title: "Job Title", key: 'jobTitle'},
        {title: "Company", key: 'company'},
        {title: "Email Sender", key: 'clientFullName'},
        {title: "Hiring Manager", key: 'hiringManager'},
        {title: "Job Department", key: 'department'},
        {title: "Date Of Interview" , key: "dateOfInterview"},
        { title: "Time Of Interview", key: 'timeOfInterview' },
        { title: "Mode Of Interview (Online/Offline)", key: 'interviewType'},
        { title: "Sender's Signature", key: 'senderSignature'},
        { title: "Reject Reason", key: 'candidateRejectReasonName'},
        { title: "Reject Reason Note", key: 'candidateRejectReasonNote'},
        { title: "Reject Reason & Note", key: 'candidateRejectReason'},
    ],
    VISIBILITY_TYPE: [
        {name: 'everyone', key: 1},
        {name: 'selected', key: 2},
        {name: "onlyMe", key: 3},
    ],
    INTERVIEWER_TYPE: [
        {name: "immediately", key: 1},
        {name: "morning", key: 2},
        {name: "2Days", key: 3},
        {name: "3Days", key: 4},
        {name: "custom", key: 5},
    ]
}

export const TAG_AND_SOURCE_TYPE = {
    TAG_FOR_CANDIDATE: 1,
    TAG_FOR_JOB: 2,
    SOURCE: 3,
}

export const QUESTIONS_TEMPLATE_TYPE = {
    EVALUATION_FORM: 1,
    QUESTIONNAIRES: 2,
    SCREENING_QUESTIONS: 3,
    EVENT_QUESTIONS: 4,
    CUSTOM_FIELDS: 5,
    VERIFICATION_TEMPLATE: 6,
    QUESTION_BANK: 7
}

export const STAGE_TIME_LIMIT = [
    {label: "No time limit", value: 0},
    {label: "1 days", value: 1},
    {label: "2 days", value: 2},
    {label: "3 days", value: 3},
    {label: "4 days", value: 4},
    {label: "5 days", value: 5},
    {label: "Add Custom Time", value: 'custom'},
]

export const JOB_TYPE = {
    TYPE: {
        INTERNAL: 1,
        PUBLIC: 2,
        PRIVATE: 3
    },
    OPTIONS: [
        {label: 'Internal', value: 1, key: 'INTERNAL', color: COLOR.u_orange},
        {label: 'Public', value: 2, key: 'PUBLIC', color: COLOR.u_blue},
        {label: 'Private', value: 3, key: 'PRIVATE', color: COLOR.u_green},
    ],
    STATUS: [
        {label: 'Open', value: false},
        {label: 'Closed', value: true},
    ]
}

/** Bulk hiring-team / hiring-manager action on the Jobs list — mirrors `ats|job|bulkHiringTeam`. */
export const JOB_BULK_HIRING_TEAM = {
    ACTION: {
        ADD: 'add',
        REMOVE: 'remove',
    },
    FIELD: {
        HIRING_TEAM: 'hiringTeam',
        HIRING_MANAGER: 'hiringManager',
    },
    /** `hrms|dropList|get` list type that returns employees. */
    EMPLOYEE_LIST_TYPE: 4,
    /** Above this many jobs the admin has to confirm before anything is written. */
    CONFIRM_ABOVE: 50,
}

export const CANDIDATE = {
    STATUS: [
        {label: 'Active Candidate', value: false},
        {label: 'Rejected Candidate', value: true},
    ],
    SORT_BY: [
        {label: 'Sort By Activity', value: 'activity'},
        {label: 'Sort By Conversation', value: 'conversation'},
        {label: 'Sort By On Create', value: 'oncreate'},
    ]
}

export const JOB_POST_TYPE = {
    INTERNAL: 1,
    PUBLIC: 2
}
// export const EXTRA_FIELD_TEMPLATES = [
//     // {name: "Expected CTC Type", value: "expectedCtcType", status: 2, type: 4, isDefault: false, proofType: null, isSalaryEnabled: false,sortOrder: null, sectionType: 2},
//     // {name: "Expected CTC", value: "expectedCtc", type: 2, status: 2, sectionType: 2, isDefault: false,sortOrder: 3},
//     // {name: "Negotiable Note", value: "negotiableNote", type: 1, status: 2, sectionType: 2, isDefault: false,sortOrder: 4},
//     { name: "Salary Range (From)", value: "salaryRangeFrom", type: 2, status: 2, sectionType: 2, isDefault: false},
//     { name: "Salary Range (To)", value: "salaryRangeTo", type: 2, status: 2, sectionType: 2, isDefault: false },
//     { name: "Expected CTC", value: "expectedCtc", type: 2, status: 2, sectionType: 2, isDefault: false },
//     { name: "Negotiable Note", value: "negotiableNote", type: 1, status: 2, sectionType: 2, isDefault: false },
//     // {name: "Notice Period", value: "noticePeriod", status: 2, type: 1, isDefault: false, proofType: null, isSalaryEnabled: false,sortOrder: null, sectionType: 2},
//     // {name: "Expected Joining Date", value: "joiningDate", status: 2, type: 7, isDefault: false, proofType: null, isSalaryEnabled: false,sortOrder: null, sectionType: 2},
//     // {name: "Reason To Change", value: "reasonToChange", status: 2, type: 4, isDefault: false, proofType: null, isSalaryEnabled: false,sortOrder: null, sectionType: 2},
//     // {name: "Reference", value: "reference", status: 2, type: 9, isDefault: false, proofType: null, isSalaryEnabled: false,sortOrder: null, sectionType: 2},
//     // {name: "Reason To Change Note", value: "reasonToChangeNote", type: 11, status: 2, sectionType: 2, isDefault: false,sortOrder: 0}

// ];

// The `type` an entry of `applicationField.fields[]` can carry.
// Mirror of constant.ATS.APPLICATION_FIELD_TYPE in backend/utils/payRollConstant/ats.js —
// keep both in sync.
export const APPLICATION_FIELD_TYPE = {
    TEXT: 1,
    EMAIL: 2,
    NUMBER: 3,
    DROP_DOWN: 4,
    SINGLE_FILE: 5,
    MULTIPLE_FILE: 6,
    DATE_PICKER: 7,
    MULTIPLE_DROP_DOWN: 8,
    MULTIPLE_DATA: 9,
    SINGLE_VALUE_OBJECT: 10,
    MULTILINE_TEXT: 11,
    IMAGE: 12,
};

export const APPLICATION_FIELD_SECTION_TYPE = {
    BASIC_INFO: 1,
    EMPLOYEE_COMMITMENT: 2,
    ORG_STRUCTURE: 3,
};

export const APPLICATION_FIELD_STATUS = { MANDATORY: 1, OPTIONAL: 2, OFF: 3 };

// Routing for `common|file|upload` when storing a candidate photo. `module` picks the product
// bucket and `featureName` the folder inside it, giving S3 keys of the shape
// files/<dbId>/RECRUIT/<userId>/candidateProfileImage/<random>.<ext>
export const PROFILE_IMAGE_UPLOAD = { MODULE: 'RECRUIT', FEATURE: 'candidateProfileImage' };

export const JOB_TEMPLATE = {
    DEFAULT_FIELDS: [
        /** type: {
         * 1 : text
         * 2 : email
         * 3 : number
         * 4 : dropDown
         * 5 : single file
         * 6 : multiple file
         * 7 : date picker
         * 8 : multiple dropDown
         * 9  : Multiple Data / Array of Objects
         * 10 : Single Value Object
         * 11 : MultiLine text
         * 12 : image (profile picture)

         /** status: {
         * 1 : mandatory
         * 2 : optional
         * 3 : off
         } */
        //  * Section Type (sectionType)
        //  * ------------------------------------------------------------
        //  * 1 : Basic Info
        //  * 2 : Employee Commitment
        //  * 3 : OrgStructure
        //  * ------------------------------------------------------------
        //  */


        // Ships OFF so no existing tenant sees a behaviour change; a recruiter opts in per job.
        // Mirror of the entry in backend/utils/payRollConstant/ats.js — keep both in sync.
        { name: "Profile Picture", value: 'profileImage', type: APPLICATION_FIELD_TYPE.IMAGE, status: APPLICATION_FIELD_STATUS.OFF, isDefault: false, sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Candidate Id", value: 'candidateId', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.MANDATORY, isDefault: false, sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "First Name", value: 'firstName', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.MANDATORY, isDefault: true,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Last Name", value: 'lastName', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.MANDATORY, isDefault: true,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Father Name", value: 'fatherName', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Marital Status", value: "maritalStatus", type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO},
        { name: "Email", value: 'email', type: APPLICATION_FIELD_TYPE.EMAIL, status: APPLICATION_FIELD_STATUS.MANDATORY, isDefault: true,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Date of Birth", value: 'dob', type: APPLICATION_FIELD_TYPE.DATE_PICKER, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false, ageRestriction: null,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Contact Number", value: 'contactNo', type: APPLICATION_FIELD_TYPE.NUMBER, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Languages", value: "knownLanguages", type: APPLICATION_FIELD_TYPE.MULTIPLE_DATA, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Education", value: "education", type: APPLICATION_FIELD_TYPE.MULTIPLE_DATA, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Previous Employer", value: "previousEmployee", type: APPLICATION_FIELD_TYPE.MULTIPLE_DATA, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false, isSalaryEnabled: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO},
        { name: "Job Title", value: 'jobTitle', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Bands", value: 'bands', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Grade", value: 'grade', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Gender", value: 'gender', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Location", value: 'location', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Department", value: 'department', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Current Address", value: "currentAddress", type: APPLICATION_FIELD_TYPE.SINGLE_VALUE_OBJECT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO},
        { name: "Permanent Address", value: "permanentAddress", type: APPLICATION_FIELD_TYPE.SINGLE_VALUE_OBJECT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO},
        { name: "Expected Joining Date", value: 'joiningDate', type: APPLICATION_FIELD_TYPE.DATE_PICKER, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.EMPLOYEE_COMMITMENT },
        { name: "Total Experience", value: 'experience', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Experience Level", value: 'experienceLevel', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Relevant Experience", value: 'relevantExperience', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Salary Type", value: 'salaryType', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.MANDATORY, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.EMPLOYEE_COMMITMENT },
        { name: "Current CTC", value: 'currentCtc', type: APPLICATION_FIELD_TYPE.NUMBER, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.EMPLOYEE_COMMITMENT },
        { name: "Expected CTC Type", value: 'expectedCtcType', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.EMPLOYEE_COMMITMENT },
        { name: "Notice Period", value: 'noticePeriod', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.EMPLOYEE_COMMITMENT },
        { name: "Reason To Change", value: 'reasonToChange', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.EMPLOYEE_COMMITMENT },
        { name: "Skills", value: 'skill', type: APPLICATION_FIELD_TYPE.MULTIPLE_DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Tags", value: 'tags', type: APPLICATION_FIELD_TYPE.MULTIPLE_DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Reference", value: "reference", type: APPLICATION_FIELD_TYPE.MULTIPLE_DATA, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.EMPLOYEE_COMMITMENT},
        { name: "Skype Id", value: 'skypeId', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Linked In", value: 'linkedIn', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Source", value: 'source', type: APPLICATION_FIELD_TYPE.DROP_DOWN, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Portfolio Links", value: 'portfolioLinks', type: APPLICATION_FIELD_TYPE.TEXT, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Resume", value: 'resume', type: APPLICATION_FIELD_TYPE.SINGLE_FILE, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
        { name: "Other Documents", value: 'otherDocuments', type: APPLICATION_FIELD_TYPE.MULTIPLE_FILE, status: APPLICATION_FIELD_STATUS.OPTIONAL, isDefault: false,sectionType: APPLICATION_FIELD_SECTION_TYPE.BASIC_INFO },
    ],}

export const REMINDER = {
    TYPE: {
        ME: 1,
        SELECTED: 2
    },
    INTERVAL_TYPE: [
        {label: 'Minutes', value: 60},
        {label: 'Hours', value: 3600},
        {label: 'Days', value: 86400},
    ],
    STATUS: [
        {label: 'Open', value: 1},
        {label: 'Archive', value: 2},
    ]
}

/**
 * Requisition fields (section 6) that are sourced from HRMS masters. The backend returns the whole
 * field list regardless of plan, so without HRMS access these are filtered out — both from the
 * Add/Edit form and from the Requisition Fields settings table.
 */
export const HRMS_REQUISITION_FIELD_KEYS = [
    'subLocation', 'subDepartment', 'category',
    'businessUnit', 'segment', 'workArea', 'costCenter', 'hub', 'territory', 'region',
    'gender', 'maritalStatus',
];

/**
 * Requisition fields whose display name is owned by the HRMS masters — they are renamed there, so
 * the Requisition Fields table offers no Edit for them. Purely about renaming: unrelated to HRMS
 * plan access, so these rows still show for every org.
 * (Job Type is an ATS setting, not an HRMS master, so it stays editable here.)
 */
export const HRMS_RENAMED_REQUISITION_FIELD_KEYS = [
    'subLocation', 'subDepartment', 'category',
    'businessUnit', 'segment', 'workArea', 'costCenter', 'hub', 'territory', 'region',
    'gender', 'maritalStatus',
    'jobTitle', 'location', 'department', 'grade', 'bands',
];

/**
 * subSection → display name for the Section column of the Requisition Fields table.
 * TODO: confirm against the backend's section-6 subSection numbering.
 */
export const REQUISITION_FIELD_SECTIONS = {
    1: 'Requisition Information',
    2: 'Job Information',
    3: 'Organization Structure',
    4: 'Basic Information',
    5: 'Job Description',
};

export const REQUISITION = {
    STATUS: {
        PENDING: 1,
        APPROVED: 2,
        REJECTED: 3,
        CANCELLED: 4,
    },
    TYPE: {
        NEW_HIRING: 1,
        REPLACEMENT: 2
    },
    TYPE_OPTION: [
        {label: 'New Hiring', value: 1},
        {label: 'Replacement', value: 2},
    ]
}

/**
 * "Setup the job" — what the approver chose after the final requisition approval.
 * Mirrors `constant.ATS.JOB_SETUP_MODE` on the backend. Both modes create the job in
 * "Awaiting setup" with the hiring team attached; they differ only in what happens next.
 */
export const JOB_SETUP = {
    MODE: {
        SEND_TO_CREATOR: 1,
        OPEN_FORM: 2,
    },
    MODE_OPTIONS: [
        {
            value: 1,
            label: 'Create the job and send it to the creator',
            note: 'recommended',
            description: 'Job is created with requisition details filled in and sits in "Awaiting setup" until the creator adds the description and publishes.',
        },
        {
            value: 2,
            label: 'Create and open the job form now',
            description: 'The job form opens straight away with requisition details filled in.',
        },
    ],
}

export const APPROVER_TYPE = {
    EMPLOYEE: 1,
    REPORTING_MANAGER: 6,
    ROLE_BASED: [2, 4, 5],
}

export const REQUISITION_AUTOMATION = {
    MODULE_NAME: 33,
    // Rule vocabulary is the shared one — never re-number it here.
    RULE_TYPE: POLICY_AUTOMATION.RULE_TYPE,
    OPERATOR: POLICY_AUTOMATION.OPERATOR,
    CONDITION_MATCH: POLICY_AUTOMATION.CONDITION_MATCH,
    CONDITION_FIELD: REQUISITION_POLICY.FIELD,
    CATEGORIES: [
        {value: 'location', fieldIndex: REQUISITION_POLICY.FIELD.LOCATION, source: 'branch'},
        {value: 'department', fieldIndex: REQUISITION_POLICY.FIELD.DEPARTMENT, source: 'department'},
        {value: 'jobTitle', fieldIndex: REQUISITION_POLICY.FIELD.JOB_TITLE, source: 'jobTitle'},
        {value: 'grade', fieldIndex: REQUISITION_POLICY.FIELD.GRADE, source: 'grade'},
        {value: 'bands', fieldIndex: REQUISITION_POLICY.FIELD.BANDS, source: 'bands'},
        {value: 'jobType', fieldIndex: REQUISITION_POLICY.FIELD.JOB_TYPE, source: 'jobType'},
        {value: 'priority', fieldIndex: REQUISITION_POLICY.FIELD.PRIORITY, source: 'priority'},
    ].map(category => ({...category, label: REQUISITION_POLICY.FIELD_LABEL[category.fieldIndex]})),
    EVENTS: {
        LIST: 'ats|requisition|approval-policy|list',
        FETCH: 'ats|requisition|approval-policy|fetch',
        CREATE: 'ats|requisition|approval-policy|create',
        UPDATE: 'ats|requisition|approval-policy|update',
        DELETE: 'ats|requisition|approval-policy|delete',
        HISTORY: 'ats|requisition|approval-policy|log|history',
        FETCH_HISTORY: 'ats|requisition|approval-policy|fetch|history',
    },
    // General activity-log type for the requisition approval policy
    LOG_TYPE: 79,
    LOG_LIMIT: 20,
    DEFAULT_APPROVAL_LEVEL: {auto_approval: false, isFinalApprove: false, level: 1},
    MAX_AUTO_APPROVE_DAYS: 100,
    MAX_APPROVAL_LEVELS: 10,
}

/** Mirror of the HRMS constant of the same name — the shared multi-level-approval opt-in. */
export const APPROVAL_FULL_CHAIN_OPTION = {
    key: 'enforceFullApprovalChain',
    label: 'Always Start Approval from Level 1',
    tooltip: 'When enabled, every request starts from Approval Level 1 and follows the complete approval chain, regardless of whether the request is submitted by a Team Leader, Project Manager, HR Manager, Admin, or on behalf of an employee.',
}

export const STATUS_OPTIONS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1, tooltip: "Document Approval pending from concerned person.."},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2,tooltip: "The document has been approved by the concerned person."},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3,tooltip: "The document has been rejected. Please delete the previously submitted documents and upload a new valid document."},
    {label: 'Cancelled', status: 'cancelled', color: '#1E2538', value: 4,},
];

export const JOB_REPORT_WIDGETS = {
    STATISTIC: 101,
    CANDIDATE_APPLIED_ANALYTICS: 102,
    CANDIDATE_SOURCE_ANALYTICS: 103,
    CANDIDATE_QUALIFIED_ANALYTICS: 104,
    CANDIDATE_GENDER_ANALYTICS: 105,
}

export const INTERVIEW = {
    STATUS: {
        PENDING: 1,
        COMPLETED: 2,
        CANCELLED: 3,
        DID_NOT_APPEAR: 4
    },
    // Mirrors backend ATS.INTERVIEW_TYPE (`type` on an interview type)
    TYPE: {
        TELEPHONIC: 1,
        ON_SITE: 2,
        GOOGLE_MEET: 3,
        ZOOM: 4,
        TEAMS: 5,
    },
    STATUS_OPTION: [
        {label: 'Pending', value: 1, color: '#FFA700'},
        {label: 'Completed', value: 2, color: '#60B158'},
        {label: 'Cancelled', value: 3, color: '#FF6961'},
        {label: 'Did Not Appear', value: 4, color: '#9A5BFF'},
        {label: 'Rescheduled' , value: 5, color: '#007AFF'},
    ]
}

export const EVENTS = {
    STATUS: {
        DRAFT: 1,
        PUBLISH: 2,
        IN_PROGRESS: 3,
        CLOSED: 4,
    },
    STATUS_OPTION: [
        {label: 'Draft', value: 1, color: '#9A5BFF'},
        {label: 'Publish', value: 2, color: '#007AFF'},
        {label: 'In Progress', value: 3, color: '#FFA700'},
        {label: 'Closed', value: 4, color: '#60B158'},
    ]
}

export const SALARY_TYPE = [
    {label: 'Yearly', value: 1},
    {label: 'Monthly', value: 2},
    {label: 'Hourly', value: 3},
]

export const EXPECTED_CTC_TYPE = [
    {label: 'Negotiable', value: 1},
    {label: 'Salary Range', value: 2},
]
export const JOB_ID = [{
    manual: 1,
    autoGenerated: 2
}]

export const DUPLICATE_HANDLING = {
    phone_and_email: `<strong>Email And Phone: </strong> If passing Email and phone number and both of them already exist in the system, it will show validation error.`,
    phone: `<strong>Phone: </strong> If passing  phone number already exist in the system, it will show validation error.`,
    email: `<strong>Email: </strong> If passing Email already exist in the system, it will show validation error.`,
    phone_or_email: `<strong>Email Or Phone: </strong> If passing Email and phone number and if anyone of them already exist in the system, it will show validation error.`,
}

export const FILE_IMAGE = {
    IMAGES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i,
    VIDEO: /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i,
    AUDIO: /\.(mp3|wav|ogg|wma|m4a|flac|mp2|aac|aiff|m4r|amr|ac3|opus|gsm|wve|w64|caf|fssd|vox|dts|amb|txw|au|spx|wv|voc|tta|ra|oga|pvf|prc|maud|8svx|snd|sndr|sndt|avr|cdda|cvs|cvsd|cvu|dvms|vms|fap|paf|sou|gsrt|hcom|htk|ima|ircam|sln|sph|nist|smp|sd2)$/i,
    EXCLUDES: ['exe', 'EXE', 'dmg', 'msi'],
    DOCS: /\.(doc|docx|DOC|DOCX|pdf|PDF|js)$/i,
    // MIXFILES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi|doc|docx|DOC|DOCX|pdf|PDF)$/i,
    MIXFILES: /\.(png|apng|jpeg|jpg|pdf|PDF)$/i,
    MIXDOC: /\.(png|apng|jpeg|jpg|pdf|PDF|doc|docx|DOC|DOCX|xlsx|xls|rtf)$/i,
    ELSXFILES: /\.(xlsx|XLSX)$/i,
};

export const COLOR_CODE = {
    u_title: '#1e2538',
    u_font: '#73788b',
    u_blue: '#007AFF',
    u_lightfont: '#c7c7c7',
    u_gray: '#e4e4e4',
    u_dark_gray: '#7b849e',
    u_datepicker_bg: '#fafbff',
    u_thead_bg: '#fafafb',
    u_icon_bg: '#4E525F',
    u_lightgreen: '#F8FDF8',
    u_darkfont: '#5D6372',
    u_semilight_gray: '#F8F9FE',
    u_white: '#FFFFFF',
    u_green: '#60B158',
    u_darkgreen: '#1A9C4A',
    u_orange: '#FFA700',
    u_pastelred: '#FF6961',
    u_black: '#000000',
    u_red: '#FF6961',
    u_purple: '#9A5BFF',
    u_lightblue: '#33D6FA',
    //for monthly calender
    u_present: '#60B158',
    u_weekend:'#2F7CF6',
    u_onlyIn:'#B58883',
    u_absent:'#FF6961',
    u_leave:'#9A5BFF',
    u_holiday:'#1EB2E1',
    u_nwd:'#FFA700',
    u_presentD:'#FF04A9',
    u_cwd:'#12CDB7',
    u_lateIn:'#007AFF',
    u_earlyOut:'#FF6961',
    u_pink: '#FF04A9'
}

export const PREBOARDING_STATUS = [
    {label: 'Initiated', color: '#60B158', value: 1, step: [1] },
    {label: 'Document & Basic info Pending', color: '#ffa700', value: 2, step: [2] },
    // {label: 'Yet To Submit', color: "#ffa700", value: 3, step: [] },
    {label: 'Document Submitted', color: "#60b158", value: 4, step: [3] },
    // {label: 'Resubmitted', color: "#60b158", value: 5, step: [] },
    {label: 'Generate Offer', color: "#007aff", value: 6, step: [4] },
    {label: 'Pending For Approval', color: "#ffa700", value: 7, step: [4] },
    {label: 'Ready To Offer', color: "#60b158", value: 8, step: [] },
    {label: 'Release Offer', color: "#60b158", value: 9, step: [4] },
    {label: 'Waiting For Candidate Approval', color: "#ffa700", value: 10, step: [5] },
    {label: 'Offer Accepted', color: "#60b158", value: 11, step: [5] },
    {label: 'Offer Declined', color: "#FF6961", value: 12, step: [5] },
    {label: 'Offer Cancelled', color: "#FF6961", value: 19, step: [5] },
    {label: 'Ready To Onboarding', color: "#60b158", value: 13, step: [6] },
    {label: 'Onboarded', color: "#60b158", value: 14, step: [6] },
    {label: 'Waiting For Author Signature', color: "#007AFF", value: 15, step: [5] },
    {label: 'Document Verified', color: "#12CDB7", value: 16, step: [3] },
    {label: 'Approval Chain Rejection', color: "#FF6961", value: 17, step: [4] },
    {label: 'Future Reference', color: "#007aff", value: 18, step: [6] },
    
    {label: 'Pending Request', color: "#ffa700", value: 20, step: [6] },
    {label: 'Reject Request', color: "#FF6961", value: 21, step: [6] },
    {label: 'Approve Request', color: "#60b158", value: 22, step: [6] },
    {label: 'Deleted Request', color: "#FF6961", value: 23, step: [6] },
];

export const STATUS_CONST = {
    INITIATED: 1,
    DOCUMENT_PENDING: 2,
    YET_TO_SUBMIT: 3,
    DOCUMENT_SUBMITTED: 4,
    RESUBMITTED: 5,
    READY_TO_OFFER: 6,
    PENDING_FOR_APPROVAL: 7,
    RELEASE_OFFER: 9,
    WAITING_FOR_CANDIDATE_APPROVAL: 10,
    OFFER_ACCEPTED: 11,
    OFFER_DECLINED: 12,
    READY_TO_ONBOARDING: 13,
    ONBOARDED: 14,
    WAITING_FOR_AUTHOR_SIGNATURE: 15,
    DOCUMENTS_VERIFIED: 16,
    APPROVAL_DECLINED: 17,
    FUTURE_REFERENCE: 18,
    CANDIDATE_OFFER_CANCEL: 19,
    // addEmployeeRequest-driven preboarding lifecycle states (mirror the
        // ONBOARDING.WORKFLOW_STATUS 7-10 set, offset into the PRE_BOARDING_STATUS range so
    // the two enums don't collide).
    //
    // EMPLOYEE_REQUEST_PENDING (20): preboarding row pushed into the addEmployeeRequest
    //   approval queue; sits here through every level of approval.
    // EMPLOYEE_REQUEST_APPROVED (22): final approval done, request is APPROVED but HR
    //   hasn't clicked "Add as Employee" yet. Recruit UI shows an "Approved – awaiting
    //   onboard" label. Flipped to ON_BOARDED only when addAsEmployee fires.
    // EMPLOYEE_REQUEST_REJECTED (21): the addEmployeeRequest tied to this preboarding row
    //   was rejected. Terminal until HR submits a fresh request (which flips back to
    //   EMPLOYEE_REQUEST_PENDING).
    // DELETED_APPROVED_REQUEST (23): the APPROVED-but-not-yet-onboarded request was
    //   soft-deleted before onboarding. Recruit UI surfaces this so HR knows a re-submit
    //   is needed.
    EMPLOYEE_REQUEST_PENDING:  20,
    EMPLOYEE_REQUEST_REJECTED: 21,
    EMPLOYEE_REQUEST_APPROVED: 22,
    DELETED_APPROVED_REQUEST:  23
}


export const PREBOARDING_STEPS = {
        KICK_OFF : 1,
        INFO_GATHERING  : 2,
        VERIFY_INFO : 3,
        RELEASE_OFFER : 4,
        OFFER_ACCEPTANCE : 5,
        HIRED :6
};
export const PRE_BOARDING_TEMPLATE_TYPE = {
        DYNAMIC : 1,
        CUSTOM : 3,
        OTHER : 2
};
export const DOCUMENT_FORMAT = [
    {label: 'A3', pageSize: '(29.7 x 42cm)', value: 'A3', width: 29.7, height: 42},
    {label: 'A4', pageSize: '(21 x 29.7cm)', value: 'A4', width: 21, height: 29.7},
    {label: 'A5', pageSize: '(14.8 x 21cm)', value: 'A5', width: 14.8, height: 21},
    {label: 'Legal', pageSize: '(21.59 x 35.56cm)', value: 'Legal', width: 21.59, height: 35.56},
    {label: 'Letter', pageSize: '(21.59 x 27.94cm)', value: 'Letter', width: 21.59, height: 27.94},
]
export const DOCUMENT_BORDER_SIZE = [
    {label: 'None', value: 0},
    {label: '1mm', value: 3},
    {label: '2mm', value: 6},
    {label: '3mm', value: 9},
    {label: '5mm', value: 15},
    {label: '10mm', value: 30},
]

export const OFFER_ACTION = {
    ACCEPTED : 1,
    REJECTED : 2,
    CANCELLED : 3,
}

export const IGNORE_DEFAULT_ALERT = [
    "ats|offerLetter|templates|update",
    "ats|offerLetter|templates|create",
]

export const APPROVAL_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    CANCELLED: 4,
};
export const ORGANIZATION_STRUCTURE_FIELDS = {
    BUSINESS_UNIT: 1,
    COST_CENTER: 2,
    BANDS: 3,
    SEGMENT: 4,
    HUB: 5,
    REGION: 6,
    TERRITORY: 7,
    ZONE: 8,
    GRADE: 9,
}

export const MULTILEVEL = new Map([
    [1, 'multilevel_verify_offer'],
    [2, 'multilevel_offer_approval'],
]);

export const MLM = {
    'multilevel_verify_offer': 1,
    'multilevel_offer_approval': 2,
};

export const uacActions = ["create", "update", "remove", "delete", "read", "approve", "reject", "assign","bulkAdd", "bulkUpdate", "comment", "viewAllTask", "revoke", "markAsComplete"]

export const allowDuplicatesEvents = ["ats|notifications|list" , "ats|interview|list"]

export const TIME_TO_FILL= {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Job', value: 5},
    ]
}

export const EMPLOYEE_TURNOVER_RATE= {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2,},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Location', value: 4},
        {label: 'Group By : Job', value: 5},
    ]
}

export const OFFER_ACCEPTANCE_RATE= {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Location', value: 4},
        {label: 'Group By : Job', value: 5},
    ]
}

export const FILL_RATE= {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2},
        {label: 'Group By : Job', value: 5},
    ]
}

export const INTERVIEW_TO_OFFER_RATIO= {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Job', value: 5},
    ]
}

export const RECRUITMENT_PIPELINE_STATUS= {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2,},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Location', value: 4},
        {label: 'Group By : Job', value: 5},
    ]
}

export const REJECTED_AND_HOLD_CANDIDATES= {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Job', value: 5},
    ]
}

export const OPENING_VS_APPLICATION_VS_ONBOARDING  = {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2,},
        {label: 'Group By : Location', value: 4},
        {label: 'Group By : Job', value: 5},
    ]
}

export const OFFER_RELEASED_VS_OFFER_ACCEPTANCE= {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Job', value: 5},
    ]
}

export const DIVERSITY_HIRING = {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2},
        {label: 'Group By : Job', value: 5},
    ]
}

export const WORKFORCE_FORECAST_VS_ACTUAL = {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2,},
        {label: 'Group By : Location', value: 4},
    ]
}

export const BUDGET_FORECAST_VS_ACTUAL_SPEND = {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2,},
        {label: 'Group By : Location', value: 4},
    ]
}

export const PAGINATION = {
    CURRENT_PAGE: 1,
    LIMIT: 40,
    LIMIT100: 100,
}

export const SCREENING_EFFICIENCY = {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2,},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Job', value: 5},
    ]
}

export const SOURCE_WISE_CONVERSION_RATE = {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2,},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Job', value: 5},
    ]
}

export const FUNNEL_OF_JOB_OPENING_STAGES = {
    GROUP_BY : [
        {label: 'Group By : All', value: 1},
        {label: 'Group By : Department', value: 2,},
        {label: 'Group By : Job Title', value: 3},
        {label: 'Group By : Job', value: 5},
        {label: 'Group By : Stage', value: 6},
    ]
}

export const FIND_USER_KEY_NAME = ["candidate", "releaseBy", "hiringManager", "recruiterUser","archivedBy","manager", "from", "to","interviewer","hiringTeam","stageManager","requestActionBy","remarkBy","requestById","requestToDbId","disqualifyBy","sharedBy","deletedBy", "referralBy", "offerActionBy", "requestedBy"];

export const CUSTOM_FIELD_TYPE = {
    TEXT: 1,
    TEXT_AREA: 2,
    EMAIL: 3,
    NUMBER: 4,
    DATE: 5,
    SELECT: 6,
    RADIO: 7,
    CHECKBOX: 8,
    FILE: 9,
    TOGGLE: 10,
    NUMBER_WITH_FILE: 11,
    TEXT_WITH_FILE: 12,
    MULTI_SELECT: 13,
    CONTACT:  14,

    1: "TEXT",
    2: "TEXT_AREA",
    3: "EMAIL",
    4: "NUMBER",
    5: "DATE",
    6: "SELECT",
    7: "RADIO",
    8: "CHECKBOX",
    9: "FILE",
    10: "TOGGLE",
    11: "NUMBER_WITH_FILE",
    12: "TEXT_WITH_FILE",
    13: "MULTI_SELECT",
    14: "CONTACT",
};
export const DEFAULT_RELATION = {
    father : "Father",
    brother : "Brother",
    sister : "Sister",
    mother : "Mother",
    spouse : "Spouse",
    children: "Children",
};
export const RELATION_TYPE = {
    FATHER: 1,
    MOTHER: 2,
    BROTHER: 3,
    SISTER: 4,
    SPOUSE: 5,
    CHILDREN: 6,
    OTHER:7
};
export const  PB_FILED_TYPE =  {
    TEXT : 1,
    EMAIL : 2,
    NUMBER : 3,
    DROPDOWN : 4,
    FILE : 5, // Only For Personal Docs
    ARR_OF_OBJ : 6, // Array Of Object, For Example Family Info
    DATE : 7
};
export const FIELD_STATUS = {
    MANDATORY : 1,
    OPTIONAL : 2,
    OFF : 3,
}

export const REPORT =  {
    JOB_WISE_CANDIDATE: 101,
    RECRUITER_WISE_CANDIDATE: 102,
    STAGE_WISE_CANDIDATE: 103,
    DISQUALIFY_CANDIDATE: 104,
    SOURCE_WISE_CANDIDATE: 105,
    JOB_WISE_HIRING_STATUS: 201,
    JOB_WISE_INTERVIEW_STATUS: 202,
    JOB_ARCHIVED: 203,
    CANDIDATE_ARCHIVED:204,
    CANDIDATE_UNARCHIVED:205,
    CANDIDATE_INACTIVE_REPORT:206,
    CANDIDATE_ACTIVE_REPORT:207,
    TIME_TO_FILL: 208,
    EMPLOYEE_TURNOVER_RATE:209,
    OFFER_ACCEPTANCE_RATE: 210,
    FILL_RATE : 211,
    INTERVIEW_TO_OFFER_RATIO: 212,
    RECRUITMENT_PIPELINE_STATUS: 213,
    REJECTED_HOLD_CANDIDATES: 214,
    OFFER_RELEASED_OFFER_ACCEPTANCE: 215,
    DIVERSITY_HIRING: 216,
    OPENINING_APPLICATION_ONBOARDING: 217,
    JOBWISE_STATUSWISE_TAG_WISE :218,
    BUDGET_FORECAST_ACTUAL_SPEND: 219,
    WORKFORCE_FORECAST_ACTUAL: 220,
    SCREENING_EFFICEINCY: 221,
    SOURCE_WISE_CONVERSATION_RATE: 222,
    FUNNEL_JOB_OPENING_STAGE: 223,
    PREBORDING_OFFER_LATTER_REPORT:225
};

export const RECRUITER_VISIBILITY_TYPE = {
    DEFAULT_VIEW: 1,
    RESTRICTED_VIEW: 2,
}
export const WEIGHTS_OPTIONS = [
    { value: 1, label: 'Equal Weights (default)', note:  'All categories have the same weight by default.'},
    { value: 2, label: 'Custom Weights', note: 'Set different weights for each category as needed.'},
];

export const PARAMETER_KEYS = [
    { label: 'Must have skill', value: 'mustHaveSkill' },
    { label: 'Good to have skill', value: 'goodToHaveSkill' },
    { label: 'Experience', value: 'experience' },
    { label: 'Education', value: 'education' },
    { label: 'Certifications', value: 'certifications' },
    { label: 'Screening Questions', value: 'screeningQuestions' },
];
export const QUESTION_MATCH_STATUS = {
    MET: 1,
    PARTIAL: 2,
    UNMET: 3,
    1: 'Correct',
    2: 'Partially Correct',
    3: 'Incorrect'
  };

export const INTERVIEW_FORM_DEFAULT_FIELDS = [
/** type: {
         * 1 : text
         * 2 : email
         * 3 : number
         * 4 : dropDown
         * 5 : single file
         * 6 : multiple file
         * 7 : date picker
         * 8 : multiple dropDown
         * 9  : Multiple Data / Array of Objects
         * 10 : Single Value Object
         * 11 : Multi line Text(TextArea)

        /** status: {
         * 1 : mandatory
         * 2 : optional
         * 3 : off
        } */
    // ---------- Basic Info ----------
    { name: "First Name", value: "firstName", type: 1, status: 1, sectionType: 1, isDefault: true,sortOrder:1 },
    { name: "Last Name", value: "lastName", type: 1, status: 1, sectionType: 1, isDefault: true,sortOrder:2 },
    { name: "Email ID", value: "email", type: 2, status: 1, sectionType: 1, isDefault: true,sortOrder:3 },
    { name: "Contact Number", value: "contactNo", type: 3, status: 2, sectionType: 1, isDefault: false,sortOrder:4 },
    { name: "Source", value: "source", type: 4, status: 2, sectionType: 1, isDefault: false,sortOrder:5 },
    { name: "Marital Status", value: "maritalStatus", type: 4, status: 2, sectionType: 1, isDefault: false,sortOrder:6 },
    { name: "Date of Birth", value: "dob", type: 7, status: 2, sectionType: 1, isDefault: false, ageRestriction: null,sortOrder:7 },
    { name: "Current Address", value: "currentAddress", type: 10, status: 2, sectionType: 1, isDefault: false,sortOrder:8 },
    { name: "Permanent Address", value: "permanentAddress", type: 10, status: 2, sectionType: 1, isDefault: false,sortOrder:9 },
    { name: "Languages", value: "knownLanguages", type: 9, status: 2, sectionType: 1, isDefault: false,sortOrder:10 },
    { name: "Education", value: "education", type: 9, status: 2, sectionType: 1, isDefault: false,sortOrder:11 },
    { name: "Previous Employer", value: "previousEmployee", type: 9, status: 2, sectionType: 1, isDefault: false, isSalaryEnabled: false,sortOrder:12},
    { name: "Reference", value: "reference", type: 9, status: 2, sectionType: 1, isDefault: false,sortOrder:13},

    // ---------- Employee Commitment ----------
    { name: "Expected Joining Date", value: "joiningDate", type: 7, status: 2, sectionType: 2, isDefault: false, sortOrder: 14 },
    { name: "Current CTC", value: 'currentCtc', type: 3, status: 2, isDefault: false, sectionType: 2, sortOrder: 15 },
    { name: "Expected CTC Type", value: 'expectedCtcType', type: 4, status: 2, sectionType: 2, isDefault: false, sortOrder: 16 },
    { name: "Expected CTC", value: 'expectedCtc', type: 3, status: 2, sectionType: 2, isDefault: false, sortOrder: 17 },
    { name: "Salary Range (From)", value: 'salaryRangeFrom', type: 2, status: 2, sectionType: 2, isDefault: false, sortOrder: 18 },
    { name: "Salary Range (To)", value: 'salaryRangeTo', type: 2, status: 2, sectionType: 2, isDefault: false, sortOrder: 19 },
    { name: "Negotiable Note", value: 'negotiableNote', type: 1, status: 2, sectionType: 2, isDefault: false, sortOrder: 20 },
    { name: "Notice Period", value: "noticePeriod", type: 1, status: 2, sectionType: 2, isDefault: false, sortOrder: 21 },
    { name: "Reason To Leaving", value: "reasonToChange", type: 4, status: 2, sectionType: 2, isDefault: false, sortOrder: 22 },
];

export const INTERVIEW_FORM_SECTIONS = {
    BASIC_INFO: 1,
    EMPLOYEE_COMMITMENT: 2,
    SALARY_DETAILS: 3
};

export const FIELD_STATUS_INTERVIEW = {
    MANDATORY: 1,
    OPTIONAL: 2,
    OFF: 3
};

export const DEFAULT_EMPLOYEE_FIELD = [
    { key: 'location', label: 'Location', section: PROFILE_SECTION?.jobInfo },
    { key: 'subLocation', label: 'Sub Location', section: PROFILE_SECTION?.jobInfo },
    { key: 'department', label: 'Department', section: PROFILE_SECTION?.jobInfo },
    { key: 'subDepartment', label: 'Sub Department', section: PROFILE_SECTION?.jobInfo },
    { key: 'jobTitle', label: 'Job Title', section: PROFILE_SECTION?.jobInfo },
    { key: 'category', label: 'Category', section: PROFILE_SECTION?.jobInfo },
    { key: 'employeeStatus', label: 'Employee Status', section: PROFILE_SECTION?.jobInfo },
]

export const WORK_OPTION = [
    { label: 'Fresher', value: 'Fresher' },
    { label: 'Experience', value: 'Experience' }
];

export const QUESTION_LEVEL = [
    { label: 'Easy', value: 1 },
    { label: 'Medium', value: 2 },
    { label: 'Hard', value: 3 },
]

export const EVALUATION_TYPE = {
    EVALUATION_FORM: 1,
    QUESTION_BANK: 2,
};

export const COLUMN_CONTROL_VIEW = {
    JOB_LIST: 'jobList',
    CANDIDATE_LIST : 'candidateTabView',
    INTERVIEW_LIST: 'interviewList',
    REMARK_YOUR_CANDIDATE: 'remarkYourCandidate',
    REMARK_OTHER_CANDIDATE: 'remarkOtherCandidate',
    SHARED_YOUR_CANDIDATE: 'sharedYourCandidate',
    SHARED_OTHER_CANDIDATE: 'sharedOtherCandidate',
    VERIFY_YOUR_CANDIDATE: 'verifyYourCandidate',
    VERIFY_OTHER_CANDIDATE: 'verifyOtherCandidate',
    PREBOARDING_KICKOFF : 'preboardingKickoff',
    PREBOARDING_INFORMATION_GATHERING : 'preboardingInformationGathering',
    PREBOARDING_VERIFY_INFORMATION : 'preboardingVerifyInformation',
    PREBOARDING_RELEASE_OFFER : 'preboardingReleaseOffer',
    PREBOARDING_OFFER_ACCEPTANCE : 'preboardingOfferAcceptance',
    PREBOARDING_HIRED : 'preboardingHired',   
    PREBOARDING_APPROVAL_REQUEST : 'preboardingApprovalRequest',
    REFERRAL_LIST : 'referralList',
    REMINDER_LIST : 'reminderList',
    REQUISITION_LIST : 'requisitionList',
    
    OFFER_LETTER_REPORT : 'offerLetterReport',
    TIME_TO_FILL_REPORT: 'timeToFillReport',
    ACTIVE_CANDIDATE_REPORT: 'activeCandidateReport',
    ALL_JOBS_HIRING_STATUS_REPORT: 'allJobsHiringStatusReport',
    ARCHIVED_CANDIDATE_REPORT: 'archivedCandidateReport',
    ARCHIVED_JOBS_REPORT: 'archivedJobsReport',
    CANDIDATE_ARCHIVED_REPORT: 'candidateArchivedReport',
    DISQUALIFY_CANDIDATE_REPORT: 'disqualifyCandidateReport',
    HIRED_CANDIDATE_REPORT: 'hiredCandidateReport',
    JOB_WISE_CANDIDATE_REPORT: 'jobWiseCandidateReport',
    JOB_WISE_INTERVIEWS_REPORT: 'jobWiseInterviewsReport',
    RECRUITER_WISE_CANDIDATE_REPORT: 'recruiterWiseCandidateReport',
    SOURCE_WISE_CANDIDATE_REPORT: 'sourceWiseCandidateReport',
    STAGE_WISE_CANDIDATE_REPORT: 'stageWiseCandidateReport',
};

// Export-mode column tabKeys for the export column picker.
export const EXPORT_COLUMN_CONTROL_VIEW = {
    CANDIDATE_LIST_EXPORT: 'candidateTabViewExport',
    PREBOARDING_KICKOFF_EXPORT: 'preboardingKickoffExport',
    PREBOARDING_INFORMATION_GATHERING_EXPORT: 'preboardingInformationGatheringExport',
    PREBOARDING_VERIFY_INFORMATION_EXPORT: 'preboardingVerifyInformationExport',
    PREBOARDING_RELEASE_OFFER_EXPORT: 'preboardingReleaseOfferExport',
    PREBOARDING_OFFER_ACCEPTANCE_EXPORT: 'preboardingOfferAcceptanceExport',
    PREBOARDING_HIRED_EXPORT: 'preboardingHiredExport',
    REQUISITION_LIST_EXPORT: 'requisitionListExport',

    // Recruit Reports (unified ats|report|export)
    JOB_WISE_CANDIDATE_REPORT_EXPORT: 'jobWiseCandidateReportExport',
    RECRUITER_WISE_CANDIDATE_REPORT_EXPORT: 'recruiterWiseCandidateReportExport',
    STAGE_WISE_CANDIDATE_REPORT_EXPORT: 'stageWiseCandidateReportExport',
    DISQUALIFY_CANDIDATE_REPORT_EXPORT: 'disqualifyCandidateReportExport',
    SOURCE_WISE_CANDIDATE_REPORT_EXPORT: 'sourceWiseCandidateReportExport',
    JOB_WISE_HIRING_STATUS_REPORT_EXPORT: 'jobWiseHiringStatusReportExport',
    JOB_WISE_INTERVIEW_STATUS_REPORT_EXPORT: 'jobWiseInterviewStatusReportExport',
    JOB_ARCHIVED_REPORT_EXPORT: 'jobArchivedReportExport',
    CANDIDATE_ARCHIVED_REPORT_EXPORT: 'candidateArchivedUnarchivedReportExport',
    CANDIDATE_ACTIVE_REPORT_EXPORT: 'candidateActiveInactiveReportExport',
    PREBORDING_OFFER_LATTER_REPORT_EXPORT: 'offerLetterReportExport',
    TIME_TO_FILL_REPORT_EXPORT: 'timeToFillReportExport',
};

export const DOC_SIGNATURE_ORDER_TYPE = {
    GROUP_ORDER: 1,
    USER_ORDER: 2,
    ALL_AT_ONCE: 3,
};

// Mirrors backend HRMS.DOCUMENT_STATUS (signatureStatus on the offer letter)
export const DOC_SIGNATURE_STATUS = {
    AWAITING_SIGNATURE: 2,
    COMPLETED: 3,
};

export const DOC_SIGNATURE_STATUS_OPTION = [
    {label: 'Awaiting Signature', value: DOC_SIGNATURE_STATUS.AWAITING_SIGNATURE, color: '#ffa700'},
    {label: 'Signed', value: DOC_SIGNATURE_STATUS.COMPLETED, color: '#60B158'},
];

// mirrors backend constant.IMPORT_REPORT_TYPE / EXPORT_REPORT_STATUS
export const IMPORT_REPORT_TYPE = {
    IMPORT_JOB: 65,
};

export const IMPORT_STATUS_VALUE = {
    PENDING: 1,
    FAILED: 2,
    SUCCESS: 3,
};

export const IMPORT_STATUS = [
    {label: 'Pending', value: IMPORT_STATUS_VALUE.PENDING, color: '#FFA700'},
    {label: 'Failed', value: IMPORT_STATUS_VALUE.FAILED, color: '#FF6961'},
    {label: 'Success', value: IMPORT_STATUS_VALUE.SUCCESS, color: '#60B158'},
];

export const JOB_IMPORT_OPTIONS = {
    JOB_POST_TYPE: ['Internal', 'Public', 'Private'],
    SALARY_TYPE: ['Yearly', 'Monthly', 'Hourly'],
    SALARY_MODE: ['Negotiable', 'Range'],
    GENDER_PREFERENCE: ['Male', 'Female', 'Transgender', 'Other'],
    SAVE_AS: ['Draft', 'Publish'],
    DATE_FORMATS: ['dd-mm-yyyy', 'dd/mm/yyyy'],
};
